import { Type } from '@angular/core';

export class SecurityExternalSettings {
  hideActivityButton?: boolean;
  debug?: boolean;
  pages: {
    groupsPage: {
      rightPanel: {
        widgets: [
          {
            component: Type<any>;
            labelKey: string;
          }
        ];
      };
    };
  };
}
